import { resolveUpdate } from './resolve';

export const createTimelineSlice = (set) => ({
  timelineDrag: null, // null | { devId|clientId, startIso, endIso } — drag création affectation
  setTimelineDrag: (suivant) =>
    set((etat) => ({ timelineDrag: resolveUpdate(suivant, etat.timelineDrag) })),
  timelineResize: null, // null | { affId, devId|clientId, edge, currentIso } — resize affectation
  setTimelineResize: (suivant) =>
    set((etat) => ({ timelineResize: resolveUpdate(suivant, etat.timelineResize) })),
  timelineGroupBy: 'dev', // 'dev' (par développeur) | 'proj' (par projet, style Float)
  setTimelineGroupBy: (suivant) =>
    set((etat) => ({ timelineGroupBy: resolveUpdate(suivant, etat.timelineGroupBy) })),
  timelineZoom: 'jour', // 'jour' | 'semaine' | 'mois' — granularité de la frise
  setTimelineZoom: (suivant) =>
    set((etat) => ({ timelineZoom: resolveUpdate(suivant, etat.timelineZoom) })),
  timelineHover: null, // null | { x, y, lines:[{label,value,color}] } — infobulle barre
  setTimelineHover: (suivant) =>
    set((etat) => ({ timelineHover: resolveUpdate(suivant, etat.timelineHover) })),
  phaseExtendConfirm: null, // { clientNom, phaseNom, phaseEnd, newEnd, onExtend }
  setPhaseExtendConfirm: (suivant) =>
    set((etat) => ({ phaseExtendConfirm: resolveUpdate(suivant, etat.phaseExtendConfirm) })),
});
